import React from 'react';
import { LineChart as RechartsLineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
interface LineChartProps {
  data: Array<{
    time: string;
    value: number;
  }>;
}
export const LineChart: React.FC<LineChartProps> = ({
  data
}) => {
  return <ResponsiveContainer width="100%" height="100%" data-id="element-43">
      <RechartsLineChart data={data} margin={{
      top: 5,
      right: 30,
      left: 20,
      bottom: 5
    }} data-id="element-44">
        <CartesianGrid strokeDasharray="3 3" stroke="#374151" data-id="element-45" />
        <XAxis dataKey="time" stroke="#9CA3AF" tick={{
        fill: '#9CA3AF'
      }} data-id="element-46" />
        <YAxis stroke="#9CA3AF" tick={{
        fill: '#9CA3AF'
      }} data-id="element-47" />
        <Tooltip contentStyle={{
        backgroundColor: '#1F2937',
        borderColor: '#374151',
        color: '#F9FAFB'
      }} data-id="element-48" />
        <Line type="monotone" dataKey="value" stroke="#3B82F6" strokeWidth={2} activeDot={{
        r: 8
      }} data-id="element-49" />
      </RechartsLineChart>
    </ResponsiveContainer>;
};